import { drizzleSchema, type PowerSyncDrizzleDB, wrapPowerSyncWithDrizzle } from "@space/powersync";
import { type Accessor, createMemo } from "solid-js";
import { usePowerSyncContext } from "@/providers/power-sync-context";

/**
 * Returns a typed Drizzle client for SolidJS.
 */
export function useDrizzle(): Accessor<PowerSyncDrizzleDB | null> {
  const { db } = usePowerSyncContext();

  const drizzle = createMemo(() => {
    const database = db();
    if (!database) {
      return null;
    }
    return wrapPowerSyncWithDrizzle(database, { schema: drizzleSchema }) as PowerSyncDrizzleDB;
  });
  return drizzle;
}
